export enum CalendarTag {
  Event = 'Event',
  Descr = 'Description'
}

export const CalendarTagsMap = new Map<CalendarTag, { tag: string; prop: string }>([
  [CalendarTag.Event, { tag: 'Event name', prop: 'Name' }],
  [CalendarTag.Descr, { tag: 'Description', prop: 'Descr' }]
]);
